import React, { useEffect, useState } from 'react';
// @ts-ignore
import cx from 'classnames';
import { routes } from 'routes';
import './style.scss';
import {
  Button,
  Divider,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Select,
} from '@material-ui/core';
import { useQuery } from '@apollo/client';
import { GET_FUNDS } from 'modules/fund/queries';
import { matchPath, NavLink, useHistory } from 'react-router-dom';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Typography from '@material-ui/core/Typography';
import { ExitToApp, Lock, Person } from '@material-ui/icons';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { kpiRoutes } from 'pages/KPIs/kpiRoutes';
import Logo from 'assets/logo_Diligent-Equity.svg';
import HelpIcon from '@material-ui/icons/HelpOutlineSharp';

export const TopBar = (props: {user: any | undefined}) => {
  const fundsQuery = useQuery(GET_FUNDS);
  const [fundsState, setFundState] = useState<any[]>();
  const [fundId, setFundId] = useState<string>();
  const [activeMenu, setActiveMenu] = useState<string>();
  const [open, setOpen] = React.useState(false);
  const { navigationPermissions = {}, belongsToPlatform = false } = props.user || {};
  const {getHelpUrl} = props.user || {};

  const anchorRef = React.useRef(null);

  const history = useHistory();

  useEffect(() => {
    if (!fundsQuery.loading) {
      setFundState(fundsQuery.data.funds);
    }
  }, [fundsQuery.loading, fundsQuery.data]);

  useEffect(() => {
    const matched = matchPath<{ fundId: string | undefined }>(
      history.location.pathname,
      {
        path: routes.FUND_SCENARIOS,
        strict: true,
        exact: true,
      },
    );
    if (history.location.pathname.indexOf('company') > 0) {
      setActiveMenu('company');
    } else if (matched) {
      setFundId(matched?.params.fundId);
      setActiveMenu('scenarios');
    } else if (history.location.pathname.indexOf('fund') > 0) {
      setActiveMenu('fund');
    } else if (history.location.pathname.indexOf('kpis') > 0) {
      setActiveMenu('kpis');
    } else {
      setActiveMenu(undefined);
    }
   
  }, [history.location.pathname]);

  let menuItems: {
    label: string,
    name?: string,
    isNew?: boolean,
    link: string,
  }[] = [];
  if (navigationPermissions.isSiteModeDefault) {
    menuItems = [
      { label: 'Dashboard', link: '/' },
      { label: 'Funds', name: 'fund', link: '/fund/' },
      { label: 'Companies', name: 'company', link: '/company/' },
      {
        name: 'scenarios',
        label: 'Scenarios',
        link: '/fund/scenarios/',
      },
      {
        name: 'kpis',
        label: 'KPIs',
        link: '/kpis/',
      },
    ];
  } else if (navigationPermissions.isSiteModeLite) {
    menuItems = [
      { label: 'Portfolio', link: '/' },
      { label: 'Companies', name: 'company', link: '/company/' },
    ];
  } else if (navigationPermissions.isLimitedPartner) {
    menuItems = [
      { label: 'Dashboard', link: '/' },
      { label: 'Funds', name: 'fund', link: '/fund/' },
      { label: 'Documents', name: 'documents', link: '/documents/' },
    ];
  } else {
    // NOTE: handle other permissions in the future
    menuItems = []
  }

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event: any) => {
    // @ts-ignore
    if (anchorRef.current && anchorRef.current?.contains(event.target)) {
      return;
    }
    let menuItem = event.target.closest('.menu-item');
    if (menuItem) {
      const href = menuItem.getAttribute('href');
      const target = menuItem.getAttribute('target');
      if (href === '/logout/') {
        const event = new CustomEvent('logout', {
          cancelable: true
        });
        // Dispatch the event.
        const cancelled = !window.dispatchEvent(event);
        if (cancelled)
          return;
      }
      if (target === '_blank') {
        window.open(href, '_blank');
      } else {
        window.location = href;
      }
    }

    setOpen(false);
  };

  const renderFund = (fund: any) => {
    let elements = [
      <MenuItem
        key={`mnu-fnd-${fund.id}`}
        className="menu-item-parent"
        value={fund.id}
      >
        {fund.name}
      </MenuItem>,
    ];
    fund.subfunds.map((subfund: any) =>
      elements.push(
        <MenuItem
          key={`mnu-fnd-${subfund.id}`}
          className="menu-item-subfund"
          value={subfund.id}
        >
          {subfund.name}
        </MenuItem>,
      ),
    );

    return elements;
  };

  return (
    <React.Fragment>
      <header className="bg-white shadow-sm">
        <div className="bg-top-banner">
          <div className="top-bar container d-flex flex-column">
            <nav className="navbar navbar-expand-lg navbar-light d-flex justify-content-between">
              <a className="navbar-brand p-0 text-light" href="#nav">
                {props.user?.ventureCapital.name}
              </a>
              <img src={Logo} alt="logo" />
              <Button
                className="fs-16 text-light"
                ref={anchorRef}
                aria-controls={open ? 'menu-list-grow' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
              >
                {props.user?.shortName}
                <i className="material-icons">arrow_drop_down</i>
              </Button>
              <Popper
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                disablePortal
                style={{ zIndex: 1 }}
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === 'bottom' ? 'center top' : 'center bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose}>
                        <MenuList>
                          {navigationPermissions.isGpOrPm &&
                              <>
                              <MenuItem
                                href={navigationPermissions.isGpOrPm ? '/admin/fund/' : '/admin/user/'}
                                onClick={handleClose}
                                className="menu-item"
                              >
                                <ListItemIcon>
                                  <Person fontSize="small" />
                                </ListItemIcon>
                                <Typography variant="inherit">Admin</Typography>
                              </MenuItem>
                              <Divider className='menu-divider' />
                            </>
                          }
                          <MenuItem
                            href="/profile"
                            onClick={handleClose}
                            className="menu-item"
                          >
                            <ListItemIcon>
                              <Person fontSize="small" />
                            </ListItemIcon>
                            <Typography variant="inherit">Profile</Typography>
                          </MenuItem>
                          {!belongsToPlatform && (
                            <MenuItem
                              href="/change-password/"
                              onClick={handleClose}
                              className="menu-item"
                            >
                              <ListItemIcon>
                                <Lock fontSize="small" />
                              </ListItemIcon>
                              <Typography variant="inherit">
                                Change Password
                              </Typography>
                            </MenuItem>
                          )}
                          <MenuItem
                            href={getHelpUrl}
                            target="_blank"
                            onClick={handleClose}
                            className="menu-item"
                          >
                            <ListItemIcon>
                              <HelpIcon fontSize="small" />
                            </ListItemIcon>
                            <Typography variant="inherit">Help Center</Typography>
                          </MenuItem>
                          <Divider className='menu-divider' />
                          <MenuItem
                            href="/logout/"
                            onClick={handleClose}
                            className="menu-item"
                          >
                            <ListItemIcon>
                              <ExitToApp fontSize="small" />
                            </ListItemIcon>
                            <Typography variant="inherit">Signout</Typography>
                          </MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </nav>
          </div>
        </div>
        <div className="top-bar container d-flex flex-column">
          <nav className="navbar navbar-expand navbar-light bg-white py-0">
            <div className="d-flex justify-content-between w-100">
              <ul className="navbar-nav">
                {menuItems.map((item, i) => (
                  <li key={`${item.label}-${i}`} className="nav-item">
                    <a
                      className={cx('nav-link text-nowrap p-3', {
                        active: item.name === activeMenu,
                      })}
                      href={item.link}
                    >
                      {item.label}
                      {item.isNew && (
                        <span className="badge badge-success ml-2 text-uppercase">
                          beta
                        </span>
                      )}
                    </a>
                  </li>
                ))}
              </ul>

            </div>
          </nav>

          {activeMenu === 'kpis' && (
            <nav className="navbar navbar-expand navbar-light bg-white submenu py-0">
              <ul className="navbar-nav">
                <li key="library" className="nav-item">
                  <NavLink
                    className="nav-link text-nowrap p-3"
                    to={routes.KPI + kpiRoutes.Library}
                  >
                    Library
                  </NavLink>
                </li>
                <li key="template" className="nav-item">
                  <NavLink
                    className="nav-link text-nowrap p-3"
                    to={routes.KPI + kpiRoutes.Templates}
                  >
                    Template
                  </NavLink>
                </li>
                <li key="status" className="nav-item">
                  <NavLink
                    className="nav-link text-nowrap p-3"
                    to={routes.KPI + kpiRoutes.CompanyStatus}
                  >
                    Status
                  </NavLink>
                </li>
                <li key="collection" className="nav-item">
                  <NavLink
                    className="nav-link text-nowrap p-3"
                    to={routes.KPI + kpiRoutes.DataEntryRoot}>
                    Collection
                  </NavLink>
                </li>
              </ul>
            </nav>
          )}
        </div>
      </header>

      {activeMenu === 'scenarios' && (
        <div className="top-bar container d-flex flex-column pt-3">
          <nav className="d-flex flex-row justify-content-between">
            {fundsState && (
              <Select
                className="fs-40"
                value={fundId || ''}
                disableUnderline={true}
                MenuProps={{
                  anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'left',
                  },
                  getContentAnchorEl: null,
                }}
                onChange={(event) => {
                  const fId = event.target.value;
                  // setFundId(fId);
                  window.location.assign(`/fund/${fId}/scenarios`);
                }}
              >
                {/* {fundsState?.filter(f => f.isSubfund === "FALSE").map((fund) => ( */}
                {fundsState?.map(fund => !fund.isSubfund && renderFund(fund))}
              </Select>
            )}
          </nav>
        </div>
      )}
    </React.Fragment>
  );
};
